module.exports = __webpack_public_path__ + "static/flags/RQ-aa66f393fdd11d6edaca06977fe60268.gif";